/**
 * The progress of a TRM's re-conversion.
 * This property would need to be manually reset to null prior to a bulk reconversion.
 * @see ReconvertRecordingsForCourtSystemTask
 */
export var TrmReconversionStatus;
(function (TrmReconversionStatus) {
    /**
     * Set by the bulk task - on finalized, it will only update to completed or failed, if in progress was set.
     * This means we will not set a reconversion status when manually calling convert recording for a single recording.
     */
    TrmReconversionStatus["InProgress"] = "in progress";
    /**
     * If the TRM was reconverted successfully
     */
    TrmReconversionStatus["Complete"] = "complete";
    /**
     * If the TRM failed to reconvert successfully
     */
    TrmReconversionStatus["Failed"] = "failed";
})(TrmReconversionStatus || (TrmReconversionStatus = {}));
